import {
  getInputFormJSON,
  i18nTranslate,
  enablePhoneVerificationInProfileUpdate,
} from 'src/utils'
import { application, getDateFromString, getParsedPhoneNumber } from 'src/utils'
import { getLocaleCodeFromUrl, isLATAM } from 'src/utils/localeUtils'
import { getLanguageDropdownBasedOnCountry } from './languageUtils'
import { getReadOnlyFields } from 'src/utils/signUpUtils'
import {
  customerContainer,
  storeContainer,
  accountsContainer,
} from 'src/models'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { FormInputLabels } from 'src/deps'
//import parsePhoneNumber from 'libphonenumber-js'
import { APPConfig } from 'config/appConfig'
import './styles.scss'
const formInputLabels = new FormInputLabels()
// const getlocal = getLocalStorage('locale')
// const country = getlocal?.split('-').length ? getlocal?.split('-')[1] : ''

export const userDetailsformInput = async (userResponse, getFormRefData) => {
  const getlocal = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })
  const locale = APPConfig?.getActiveAppConfig()?.defaultLocale //en_US
  const country = getlocal?.split('_').length ? getlocal?.split('_')[1] : ''
  const commonConfigJSON = getInputFormJSON(locale) || {}
  const enableReadonlyFields = APPConfig?.getAppConfig()?.enableReadonlyFields

  const isDefaultLanguage =
    enableReadonlyFields?.defaultLanguageReadOnly?.language || ''
  //checking with readonly function below
  const disableFirstNameField = getReadOnlyFields('firstNameReadOnly', country)
  const disableLastNameField = getReadOnlyFields('lastNameReadOnly', country)
  const defaultLanguageCountries = getReadOnlyFields('addressReadOnly', country)

  const isEmailVerified = userResponse?.customProperties?.isEmailVerifiedFlag
  let showEmailVerificationStatus = ''
  if (isEmailVerified === 'true') {
    showEmailVerificationStatus = 'valEmail'
  } else {
    showEmailVerificationStatus = 'notValEmail'
  }
  const isPhoneNumberVerified =
    userResponse?.customProperties?.isPhoneNumberVerified || ''
  let showPhoneVerificationStatus = ''
  if (isPhoneNumberVerified === 'true') {
    showPhoneVerificationStatus = 'valPhone'
  } else {
    showPhoneVerificationStatus = 'notValPhone'
  }

  let addExtraSpaceInEmail = ''
  let addExtraSpaceInPhone = ''

  if (
    (isEmailVerified === 'false' && isPhoneNumberVerified === 'false') ||
    (isEmailVerified === 'false' && isPhoneNumberVerified === '')
  ) {
    addExtraSpaceInEmail = 'addEmailSpace'
  } else if (isEmailVerified === 'false' && isPhoneNumberVerified === 'true') {
    addExtraSpaceInPhone = 'addPhoneSpace'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === 'true') {
    addExtraSpaceInEmail = 'addEmailSpaceAllTrue'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === 'false') {
    addExtraSpaceInEmail = 'addEmailSpaceTrue'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === '') {
    addExtraSpaceInEmail = 'addEmailSpaceNoPhone'
  } else {
    addExtraSpaceInEmail = addExtraSpaceInPhone = 'd-none'
  }

  const firstName =
    acctype1 == 'Brand Affiliate - Business Entity'
      ? userResponse?.accounts?.name || ''
      : userResponse?.firstName || ''
  const lastName = userResponse?.lastName || ''
  const email = userResponse?.email || ''
  const phoneNumber = userResponse?.phoneNumber || ''

  //Start of parse phonenumber code
  const userCountry =
    userResponse?.accounts?.properties?.find(
      element => element.attributeId === 'countryCode'
    )?.value || ''
  const localCountry = userCountry
    ? userCountry
    : storeContainer?.storeIDValue === 'Canada'
      ? 'CA'
      : storeContainer?.storeIDValue
  let inputCode = countryData()?.find(
    element => element.value === localCountry
  )?.value
  let phoneNumberCode = ''
  if (phoneNumber) {
    let phoneCountry = ''
    const parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

    phoneNumberCode = parsedPhoneNumber?.phoneNumberCode
    if (phoneNumberCode === undefined) {
      phoneNumberCode = phoneNumber
    }
    phoneCountry = parsedPhoneNumber?.phoneCountry

    inputCode = phoneCountry || inputCode
  }

  let phoneCountryCodeOptions = []
  countryData()?.forEach(val => phoneCountryCodeOptions.push(val))
  //End of parse phonenumber code

  const gender = userResponse?.gender || ''
  const preferredLanguage = defaultLanguageCountries
    ? isDefaultLanguage
    : userResponse?.customProperties?.preferredLanguage || ''
  const preferredName = userResponse?.customProperties?.preferredName || ''
  const acctype1 = userResponse?.accounts?.type || ''
  const disableFnLn =
    acctype1 == 'Brand Affiliate' ||
    acctype1 == 'Brand Affiliate - Business Entity'
      ? true
      : false

  let homeCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      homeCountry = element.value
    }
  })
  const selectLanguage = getLanguageDropdownBasedOnCountry(homeCountry)
  // todo: to check whether country is LATAM :  selectAllLanguages
  // isLATAM ? selectLanguageLATAM : selectAllLanguages

  //Date of Birth Condition check start
  let dob = getDateFromString(userResponse?.dateOfBirth)
  const disableDateOfBirth = dob.time === '' && homeCountry ? false : true
  //Date of Birth Condition check end

  if (homeCountry === 'CA') {
    homeCountry = 'Canada'
  }
  const storeIdBasedOnCountry = storeContainer.storeIDValue
  const handleLang = (event, setFieldValue, optionValue) => {
    setFieldValue('preferredLanguage', optionValue)
  }

  let selectedLanguage =
    selectLanguage?.find(
      option =>
        option?.value === preferredLanguage ||
        option?.label === preferredLanguage
    ) ||
    selectLanguage?.[0] ||
    []

  let selectedLanguageValue = selectedLanguage?.value || preferredLanguage
  let selectedLanguageLabel = selectedLanguage?.label || preferredLanguage
  const hasOnlyOneLanguagePreference =
    selectLanguage && selectLanguage?.length == 1

  const isToEnableEmailVerification =
    APPConfig?.getAppConfig()?.enableEmailVerification == 'true' || false

  const phoneNumberLabel = 'mobilePhoneNumber'
  const countryCodeLabel = 'phoneCountryCode'
  const nameLabel = 'firstName'
  const verifyBtnLabel = 'Verify'

  customerContainer.setVerifyPhone = {
    phoneCountryCode: inputCode,
    phoneNumber: phoneNumberCode,
    name: firstName,
  }

  return [
    [
      {
        name: i18nTranslate('contactInformation', 'Contact Information'),
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 h1 contactInfo',
      },
      {
        name: 'required_note',
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 required-note',
      },
      {
        name: nameLabel,
        columnType: {
          lg: '6',
        },
        defaultValue: firstName,
        disabled:
          disableFirstNameField ||
          disableFnLn ||
          homeCountry !== storeIdBasedOnCountry
            ? true
            : false,
        dataTestId: 'qa-first-name',
        placeholderKey: 'firstNamePlaceHolder',
        ariaLabel: nameLabel,
        maxLength: commonConfigJSON?.name?.maxLength || 35,
        required: true,
      },
      {
        name: 'lastName',
        columnType: {
          lg: '6',
        },
        defaultValue: lastName,
        disabled:
          disableLastNameField ||
          disableFnLn ||
          homeCountry !== storeIdBasedOnCountry
            ? true
            : false,
        dataTestId: 'qa-last-name',
        placeholderKey: 'lastNamePlaceHolder',
        ariaLabel: 'lastName',
        maxLength: commonConfigJSON?.name?.maxLength || 35,
        required: true,
      },
      {
        name: 'DoB',
        type: 'date',
        isToHideLabel: true,
        disabled: disableDateOfBirth,
        columnType: {
          lg: '6',
        },
        defaultValue: dob.date,
        ariaLabel: 'DoB',
        maxLength: 15,
        customClassName: 'mb-2',
        required: false,
        toolTipInfo: formInputLabels.getFormLabels('distributorMinAge'),
        isFromProfile: true,
        accountDobDisabled: false,
      },
    ],
    homeCountry === storeIdBasedOnCountry
      ? [
          {
            name: i18nTranslate('profileData.email', 'Email'),
            type: 'div',
            columnType: {
              lg: '12',
            },
            customClassName: 'my-1 h1 emailInfo',
          },
          {
            name: 'required_note',
            type: 'div',
            columnType: {
              lg: '12',
            },
            customClassName: 'my-1 required-note',
          },
          {
            name: 'email',
            type: 'accEmail',
            columnType: {
              lg: '12',
            },
            defaultValue: email,
            customClassName: accountsContainer?.duplicateEmailExist
              ? 'duplicate-info-exist ada-checkmark add-box-height'
              : 'ada-checkmark add-box-height',
            ariaLabel: 'email',
            dataTestId: 'qa-my-profile-email',
            maxLength: commonConfigJSON?.email?.maxLength || 100,
            required: true,
            disabled:
              homeCountry !== storeIdBasedOnCountry
                ? true
                : false || !isToEnableEmailVerification,
            placeholderKey: 'emailAddressPlaceHolder',
          },
          {
            type: showEmailVerificationStatus + 'SMSVerify',
            isToHideLabel: true,
            columnType: {
              lg: '12',
            },
            customClassName: 'mb-2',
          },
          {
            type: 'div',
            isToHideLabel: true,
            columnType: {
              lg: '12',
            },
            customClassName: `${addExtraSpaceInEmail}`,
          },
        ]
      : [
          {
            name: 'required_note',
            type: 'div',
            columnType: {
              lg: '12',
            },
            customClassName: 'my-1 required-note',
          },
          {
            name: 'emailText',
            type: 'accEmail',
            columnType: {
              lg: '12',
            },
            defaultValue: email,
            customClassName: 'ada-checkmark',
            ariaLabel: 'email',
            dataTestId: 'qa-my-profile-email',
            required: true,
            disabled:
              homeCountry !== storeIdBasedOnCountry
                ? true
                : false || !isToEnableEmailVerification,
            placeholderKey: 'emailAddressPlaceHolder',
          },
        ],
    [
      {
        name: i18nTranslate('profileData.phoneNumber', 'Phone Number'),
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 h1 phoneInfo',
      },
      {
        name: 'required_note',
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 required-note',
      },
      {
        name: countryCodeLabel,
        type: 'select',
        options: [...phoneCountryCodeOptions],
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '0' : '4'
          }`,
          md: '12',
        },
        dataTestId: 'qa-dropdown-countrycode',
        defaultValue: inputCode,
        ariaLabel: countryCodeLabel,
        required: true,
        phoneNumberDropDown: true,
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
        onInput: event => {
          customerContainer.setVerifyPhone.phoneCountryCode =
            event?.target?.value
        },
      },
      {
        name: phoneNumberLabel,
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '0' : '8'
          }`,
          md: '12',
        },
        dataTestId: 'qa-create-account-phone',
        customClassName: 'add-box-height',
        placeholderKey: 'phoneNoPlaceHolder',
        defaultValue: phoneNumberCode,
        ariaLabel: phoneNumberLabel,
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
        maxLength: 15,
        type: 'mask',
        verifyBtnLabel: verifyBtnLabel,
      },
      enablePhoneVerificationInProfileUpdate() && {
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'labelInfoText',
        labelInfo: i18nTranslate(
          'phoneLabel.labelInfoText',
          "We'll text a code to verify this number. Fees may apply."
        ),
      },
      {
        type: showPhoneVerificationStatus,
        isToHideLabel: true,
        columnType: {
          lg: '12',
        },
      },
      {
        type: 'div',
        isToHideLabel: true,
        columnType: {
          lg: '12',
        },
        customClassName: `${addExtraSpaceInPhone}`,
      },
      {
        name: verifyBtnLabel,
        type: 'button',
        columnType: {
          lg: '12',
        },
        isToHideLabel: true,
        defaultValue: 'Verify',
        dataTestId: 'qa-verify-button',
        value: i18nTranslate('accountProfile.verifyButton', 'Verify'),
        onClick: event => {
          const parentDOM = event.target.parentNode
          if (!parentDOM.classList.contains('disable')) {
            typeof getFormRefData === 'function' && getFormRefData()
            customerContainer.verifyPhonePopup = true
          }
        },
        customClassName: `phoneVerifyBtn my-1 ${
          !phoneNumberCode ? 'disable' : ''
        } ${showPhoneVerificationStatus === 'notValPhone' ? '' : 'd-none'}`,
      },
    ].filter(Boolean),
    [
      {
        name: i18nTranslate(
          'profileData.preferredLanguage',
          'Preferred Language'
        ),
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 h1 languageInfo',
      },
      hasOnlyOneLanguagePreference
        ? {
            type: 'text',
            name: 'preferredLanguage',
            defaultValue: selectedLanguageValue,
            dataTestId: 'qa-preferred-language',
            disabled: true,
            value: selectedLanguageLabel,
            customClassName: 'preferred-language-field',
          }
        : {
            name: 'preferredLanguage',
            type: 'dropdown',
            columnType: {
              lg: '12',
            },
            onChange: handleLang,
            defaultValue: selectedLanguageValue,
            options: selectLanguage,
            toolTip: 'langauge', //Important// Do not change value of toolTip
            disabled:
              defaultLanguageCountries ||
              homeCountry !== storeIdBasedOnCountry ||
              hasOnlyOneLanguagePreference
                ? true
                : false,
          },
    ],
  ]
}
